<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5" data-testid="impact-ursache-detail">
    <div>
      <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-3 m-0">
        {{ $t('UserProjects.impactAnalysis.ursache.distributionTitle') }}
      </p>
      <div v-if="!distribution.length" class="text-[13px] text-[var(--color-disabled)]">
        {{ $t('UserProjects.impactAnalysis.ursache.emptyCauses') }}
      </div>
      <div v-else class="space-y-2.5">
        <div
          v-for="row in distribution"
          :key="row.label"
          class="flex items-center gap-3"
        >
          <span class="text-[13px] text-[var(--color-dark)] w-48 shrink-0 truncate">
            {{ row.label }}
          </span>
          <div class="flex-1 h-6 rounded-full overflow-hidden bg-[#F0F0F0]">
            <div
              class="h-full rounded-full bg-[var(--color-orange)]"
              :style="{ width: `${barWidth(row.count)}%` }"
            />
          </div>
          <span class="text-[13px] font-medium text-[var(--color-dark)] w-6 text-right">
            {{ row.count }}
          </span>
        </div>
      </div>
      <p class="text-[12px] text-[var(--color-disabled)] mt-3 mb-0">
        {{ $t('UserProjects.impactAnalysis.ursache.basis', { n: totalBreaks, period: periodLabel }) }}
      </p>
    </div>

    <div>
      <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-3 m-0">
        {{ $t('UserProjects.impactAnalysis.ursache.constraintsTitle') }}
      </p>
      <div v-if="!items.length" class="text-[13px] text-[var(--color-disabled)]">
        {{ $t('UserProjects.impactAnalysis.ursache.emptyConstraints') }}
      </div>
      <div v-else class="space-y-2">
        <router-link
          v-for="item in visibleItems"
          :key="item.id"
          to="/user-projects/constraints"
          class="w-full flex items-center gap-3 p-3 rounded-[10px] border border-[#E5E5E5] hover:bg-[#FAFAFA] no-underline text-left"
        >
          <span
            class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0"
            :style="priorityStyle(item.priority)"
          >
            {{ (item.priority || 'medium').toUpperCase() }}
          </span>
          <div class="flex-1 min-w-0">
            <p class="text-[13px] font-medium text-[var(--color-dark)] truncate m-0">
              {{ item.title }}
            </p>
            <p class="text-[12px] text-[var(--color-disabled)] m-0">
              {{ item.type }} · {{ item.ownerLabel || '—' }} · {{ item.sinceLabel }}
            </p>
          </div>
        </router-link>
      </div>
      <p class="text-[12px] text-[var(--color-disabled)] mt-3 mb-0">
        {{ summary.intern }} intern · {{ summary.cross }} cross
      </p>
      <router-link
        to="/user-projects/constraints"
        class="text-[12px] font-medium no-underline hover:underline mt-1 inline-block"
        style="color: #EAB308"
      >
        {{ $t('UserProjects.impactAnalysis.ursache.viewAllConstraints') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { causeBarWidth, maxCauseCount } from '@/utils/impactAnalysisDisplay';

export default {
  name: 'ImpactUrsacheDetail',
  props: {
    distribution: { type: Array, default: () => [] },
    totalBreaks: { type: Number, default: 0 },
    items: { type: Array, default: () => [] },
    summary: { type: Object, default: () => ({ total: 0, intern: 0, cross: 0 }) },
    periodLabel: { type: String, default: '' },
  },
  computed: {
    maxCount() {
      return maxCauseCount(this.distribution);
    },
    visibleItems() {
      return (this.items || []).slice(0, 5);
    },
  },
  methods: {
    barWidth(count) {
      return causeBarWidth(count, this.maxCount);
    },
    priorityStyle(priority) {
      const key = String(priority || 'medium').toLowerCase();
      if (key === 'high' || key === 'hoch') {
        return { backgroundColor: '#FEF2F2', color: '#EF4444' };
      }
      if (key === 'low' || key === 'niedrig') {
        return { backgroundColor: '#F5F5F5', color: '#ABABAB' };
      }
      return { backgroundColor: '#FEFCE8', color: '#EAB308' };
    },
  },
};
</script>
